import config from '../config';
import axios from 'axios';

// GET REQUESTS
const GET_GENERAL_INFO = `${config.API_URL}/EBFSAPlans/ByCaseid`;
const GET_PAY_SCHEDULE_FREQUENCIES = `${config.API_URL}/EBFSAPlans/ByCaseid`;
const GET_ENROLLMENT = `${config.API_URL}/EBFSAPlans/ByCaseid`;
const GET_FSA_PLAN = `${config.API_URL}/EBFSAPlans/ByCaseid`;
const GET_HRA_PLANS = `${config.API_URL}/EBFSAPlans/ByCaseid`;

// POST REQUESTS
const POST_HRA_PLAN = `${config.API_URL}/EBFSAPlans/ByCaseid`;

// PATCH REQUESTS
const PATCH_GENERAL_INFO = `${config.API_URL}/EBFSAPlans/ByCaseid`;
const PATCH_ENROLLMENT = `${config.API_URL}/EBFSAPlans/ByCaseid`;
const PATCH_FSA_PLAN = `${config.API_URL}/EBFSAPlans`;
const PATCH_HRA_PLAN = `${config.API_URL}/EBFSAPlans/ByCaseid`;


const EmployeeBenefitsService = {

    async getFSAPlanByCaseID(id) {
        try {
            const response = await axios.get(`${GET_FSA_PLAN}/${id}`);
            console.log(response);
            return response.data;
        } catch (error) {
            console.error('Error fetching posts:', error);
            throw error;
        }
    },

    async patchFSAPlanByCaseID(id, data) {
        try {
            const response = await axios.patch(`${PATCH_FSA_PLAN}/${id}`, data);
            console.log(response);
            return response.data;
        } catch (error) {
            console.error('Error fetching posts:', error);
            throw error;
        }
    },
};

export default EmployeeBenefitsService;
